import { EventsRouteBase } from 'mewe/routes/mixins/events-route-base';

export default EventsRouteBase;
